<template>
  <div class="exchangeRateInfoLog">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.exchangeRateInfo.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="list-item">
          {{ $t.exchangeRateInfo.log }}：{{ item.OperationLog }}
        </div>
        <div class="list-item">
          {{ $t.exchangeRateInfo.content }}：{{ item.LogContent }}
        </div>
        <div class="list-item">
          {{ $t.exchangeRateInfo.username }}：{{ item.OperationUserName }}
        </div>
        <div class="list-item">
          {{ $t.exchangeRateInfo.createTime }}：{{ item.CreateTime }}
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List, Row, Col, Search, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Search).use(Button).use(Form).use(Field);

export default {
  name: "exchangeRateInfoLog",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
    };
  },
  created() {},
  methods: {
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        OperationLog: this.searchText,
      };
      this.$api.financialManagement
        .getExchangeRateLogList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.exchangeRateInfoLog {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>